import React, { useState, useEffect, useMemo } from "react";
import { Button, useTheme, Box, IconButton, Stack, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, Typography } from "@mui/material";
import { tokens } from "../../assets/theme";
import { useQuery } from "@tanstack/react-query";
import { useLocalStorage } from "../../hooks/useLocalStorage";
//Components
import AxionControls from "../../components/controls/AxionControls";
import { pushErrorMessage } from "../../utils/notifications";
import AxionConfirmation from '../../components/controls/AxionConfirmation';
import Controls from "../../components/controls/Contols";
//Hooks
import { getTopLevelGroups, patchTopLevelGroup, postTopLevelGroup, deleteTopLevelGroup} from "../../fetchers/incidentTopLevelCategoryGroup";
//Icons
import SaveIcon from '@mui/icons-material/Save';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
//Language
import messages from "./messages";
import { FormattedMessage, useIntl } from "react-intl";
import { event } from "jquery";


export default function EditTopLevelGroups(props) {

    const { formatMessage } = useIntl();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [companyKey, setCompanyKey] = useLocalStorage("companyKey", 1);

    const [newGroup, setNewGroup] = useState({ id: null, name: "", companyId: companyKey, sortorder: 0 });
    const [showAddGroup, setShowAddGroup] = useState(true);
    const [openGroup, toggleOpenGroup] = React.useState(false);

    const [confirmationTitle, setConfirmationTitle] = useState("");
    const [confirmationMessage, setConfirmationMessage] = useState("");
    const [groupId, setGroupId] = useState(null);
    const [openConfirmationGroup, setOpenConfirmationGroup] = useState(false);

    const groupsQuery = useQuery(
        ["Groups", companyKey],
        () => getTopLevelGroups(companyKey),
        {}
    );

    const handleCloseGroupDialog = () => {
        setNewGroup({ id: null, name: "", companyId: companyKey, sortorder: 0 });;
        toggleOpenGroup(false);
    };

    const handleAddGroup = () => {

        console.log("new/edit Group", newGroup);

        if (newGroup.id !== null) {
            patchTopLevelGroup(newGroup).then(() => {
                groupsQuery.refetch();
                handleCloseGroupDialog();
            }).catch((error) => {
                console.log(error);
                //setShowBackdrop(false);
                pushErrorMessage(formatMessage(messages.could_not_update_group));
            });
        } else {

            postTopLevelGroup(newGroup).then(() => {
                groupsQuery.refetch();
                handleCloseGroupDialog();
            }).catch((error) => {
                console.log(error);
                //setShowBackdrop(false);
                pushErrorMessage(formatMessage(messages.could_not_create_group));
            });
        }
    }

    const handlePrepareAddGroup = () => {

        toggleOpenGroup(true);
        setShowAddGroup(true);
        //setShowAddValue(false);
    }

    const handleNameChange = (event) => {
        let group = { ...newGroup };
        group.name = event.target.value;
        setNewGroup(group);
    }

    const handleEditGroupClick = (id) => {
        var dim = groupsQuery.data?.filter(d => d.id === id);

        var tempGroup = { ...newGroup };
        tempGroup.id = id;
        tempGroup.name = dim[0].name;
        //tempgroup.companyId = companyId;
        setNewGroup(tempGroup);
        toggleOpenGroup(true);
    }

        const handleDeleteGroup = (id) => {
            setGroupId(id);
            setConfirmationTitle(formatMessage(messages.delete_group));
            setConfirmationMessage(formatMessage(messages.sure_delete_group));
            setOpenConfirmationGroup(true);
        }
    
        const doDeleteGroup = () => {
            setConfirmationTitle("");
            setConfirmationMessage("");
            setOpenConfirmationGroup(false);
    
            deleteTopLevelGroup(groupId).then(() => {
                groupsQuery.refetch();
            }).catch((error) => {
                console.log(error);
                //setShowBackdrop(false);
                pushErrorMessage(formatMessage(messages.could_not_delete_group));
            })
        }
    
        const cancelDeleteGroup = () => {
            setGroupId(null);
            setConfirmationTitle("");
            setConfirmationMessage("");
            setOpenConfirmationGroup(false);
        }

    return (
        <>
            <Box padding="30px"> </Box>
            <Box width="50%">
                <Box width="100%" justifyContent="flex-start" alignItems="center" display="flex" marginTop="10px" marginBottom="20px" marginLeft="15px">

                        <Controls.Button
                            onClick={handlePrepareAddGroup}
                            text={formatMessage(messages.add_group)}
                            startIcon={<AddCircleOutlinedIcon />}
                            sx={{
                                "&:hover": {
                                    backgroundColor: colors.dashbordGreen[700],
                                },
                                backgroundColor: colors.dashbordGreen[500],
                                color: "#000000",
                            }}
                        />
                </Box>
                {/* {(dimensionsQuery?.data?.length > 0) && <Box marginTop="20px" color="#ffffff" marginLeft="10px">Dimensions and values</Box>} */}
                <Stack direction="column" width="100%" overflow="hidden" backgroundColor={colors.primary[300]} marginTop="5px" color="#ffffff" spacing="1px" marginLeft="15px">
                    <Box width="100%" alignItems="center" justifyContent="flex-start" display="flex" marginLeft="10px" backgroundColor={colors.primary[400]} padding="5px"><FormattedMessage {...messages.groups} /></Box>
                    {groupsQuery?.data?.sort((a, b) => (a.name > b.name) ? 1 : -1).map((a) => {
                        return (
                            <>
                                <Stack direction="row" width="100%" backgroundColor={colors.primary[500]}>

                                    <Box width="70%" alignItems="center" justifyContent="flex-start" display="flex" marginLeft="10px" onClick={() => handleEditGroupClick(a.id)}>{a.name}</Box>
                                    <Box width="30%" justifyContent="flex-end" alignItems="center" display="flex">

                                        <Tooltip title={<Typography fontSize="12px"><FormattedMessage {...messages.edit_group} /> {a.name}</Typography>}>
                                            <IconButton onClick={() => { handleEditGroupClick(a.id) }}><EditOutlinedIcon /></IconButton>
                                        </Tooltip>
                                        <Tooltip title={<Typography fontSize="12px"><FormattedMessage {...messages.delete_group} /></Typography>}>
                                                <IconButton onClick={() => { handleDeleteGroup(a.id) }} ><DeleteOutlinedIcon /></IconButton>
                                        </Tooltip>
                                    </Box>
                                </Stack>
                            </>
                        )
                    })}
                    <Box padding="0px"> </Box>
                </Stack>
            </Box>

            <Dialog open={openGroup} onClose={handleCloseGroupDialog} m={0} width="400px">
                <Box m={0} sx={{ backgroundColor: colors.primary[400], borderRadius: "4px" }} width="400px" >
                    {/* <form onSubmit={handleAddDimension}> */}
                    <DialogTitle>{(newGroup.id === null) ? <FormattedMessage {...messages.add_a_new_group} /> : <FormattedMessage {...messages.update_a_group} />}</DialogTitle>
                    <DialogContent>

                        <Stack direction="column" width="100%" overflow="hidden" >
                            <Box><AxionControls.AxionTextBox
                                label={<FormattedMessage {...messages.lbl_name} />}
                                value={newGroup.name}
                                autoComplete="new-password"
                                inputProps={{ autoComplete: 'new-password' }}
                                onChange={(event) =>
                                    handleNameChange(event)
                                }
                            /></Box>
                        </Stack>
                        <Stack direction="row" width="100%" overflow="hidden" marginTop="15px" display="flex" justifyContent="flex-end">
                            <Controls.Button
                                text={<FormattedMessage {...messages.btn_close} />}
                                onClick={handleCloseGroupDialog}
                                // startIcon={<SaveIcon />}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: "#535560",
                                    },
                                    backgroundColor: colors.primary[300],
                                    color: "#000000",

                                }}
                            />
                            <Controls.Button
                                marginLeft="10px"
                                text={(newGroup.id === null) ? formatMessage(messages.add_group) : formatMessage(messages.edit_group)}
                                onClick={handleAddGroup}
                                startIcon={<SaveIcon />}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: colors.dashbordGreen[700],
                                    },
                                    backgroundColor: colors.dashbordGreen[500],
                                    color: "#000000",
                                    marginLeft: "10px"
                                }}
                            />
                        </Stack>
                    </DialogContent>
                </Box>
            </Dialog>


          <AxionConfirmation open={openConfirmationGroup} title={confirmationTitle} message={confirmationMessage} onConfirm={doDeleteGroup} onCancel={cancelDeleteGroup} cancelText={formatMessage(messages.no)} confirmText={formatMessage(messages.yes)} />
           {/*  <AxionConfirmation open={openConfirmationValue} title={confirmationTitle} message={confirmationMessage} onConfirm={doDeleteDimensionValue} onCancel={cancelDeleteDimensionValue} cancelText={formatMessage(messages.no)} confirmText={formatMessage(messages.yes)} /> */}



        </>

    )

}